import React, { useContext, useState } from "react"

import { useQuery } from "@tanstack/react-query";

import { Link } from "react-router-dom";
import { Button, Col, Grid, Form, Row, Input, Select, Popconfirm, Space } from "antd";
import { MinusOutlined, PlusOutlined, StopOutlined, StopTwoTone } from "@ant-design/icons";

import { Conjunto } from "../../../Components/Conjunto";
import { Formatacoes } from "../../../Utils/Formatacao";
import { Ordenar } from "../../../Utils/Ordenacao";
import { ResponsiveAntdTable } from "../../../Components/ResponsiveAntdTable";
import { Restrito } from "../../../Components/Restrito";
import { SessaoContext } from "../../../Contexts/SessaoContext";

import AdicionarAjuda, { ITutorial } from "../../../Components/AdicionarAjuda";
import { InputComReactIMask } from "../../../Components/InputComReactIMask";
import { useForm } from "antd/lib/form/Form";

import { Permissoes } from "../../../Constants/Permissoes";
import { PropriedadesDoPopConfirm } from "../../../Defaults";
import { TypeResponsavel } from "../../../Models/Domain/Pessoa/Responsavel";
import { ResponsavelService } from "../../../Services/Domain/Pessoa/ResponsavelService";

import { EnumTipoDeDocumento } from "../../../Models/Domain/Pessoa/Enum";
import { DescricaoDoResponsavel } from "../../Viagem/Cadastros/Viagem/Componentes/DescricaoDoResponsavel";

import * as Tutoriais from "./tutorial"
import PessoaBloqueioBloquearModal from "@/Components/Populados/Pessoa/PessoaBloqueio/PessoaBloqueioBloquearModal";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import TablePaginadaBasic from "@/Components/Base/Table/TablePaginadaBasic";
import PessoaBloqueioModal from "@/Components/Populados/Pessoa/PessoaBloqueio/PessoaBloqueioModal";
import { EnumBloqueioTipo } from "@/Models/Pessoa/Bloqueio/BloqueioTipo";

export const ListagemDeResponsaveis: React.FC<{
    aoAdicionar?: () => void,
    aoEditar?: (aluno: TypeResponsavel) => any,

    hrefDoBotaoAdicionar?: string,
    hrefDoBotaoEditar?: (aluno: TypeResponsavel) => string | void
}> = (props) => {

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const tamanhoDaTela = Grid.useBreakpoint();
    const usuario = useContext(SessaoContext)?.sessao?.usuario;

    interface IFiltro {
        ativo?: boolean,
        nome?: string,
        cpf?: string,
        tipoDeDocumento?: TypeResponsavel["tipoDeDocumento"],
        documento?: TypeResponsavel["documento"],
        paginaInfo ?: PaginaInfo
    }

    const [filtro, setFiltro] = useState<IFiltro>({
        ativo: true,
        paginaInfo : new PaginaInfo()
    });

    const [ form ] = useForm<IFiltro>()

    // const alunosDisponiveis = useQuery({
    //     queryKey: ["listarResponsaveis", filtro],
    //     queryFn: () => new ResponsavelService().listar({
    //         ativo: filtro.ativo,
    //         pessoa: {
    //             nome: filtro.nome?.trim() == "" ? undefined: filtro.nome,
    //             cpf: filtro.cpf?.trim() == "" ? undefined: filtro.cpf,
    //         },
    //         tipoDeDocumento: filtro.tipoDeDocumento,
    //         documento: filtro.documento?.trim() == "" ? undefined: filtro.documento,
    //     }),
    //     enabled: true,
    // });

    const {
        data : data,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ["listarResponsaveis", "listarResponsaveisPagina", filtro],
        queryFn: () => new ResponsavelService().listarPagina(
            filtro?.paginaInfo ?? new PaginaInfo(),
            {
                ativo: filtro.ativo,
                pessoa: {
                    nome: filtro.nome?.trim() == "" ? undefined: filtro.nome,
                    cpf: filtro.cpf?.trim() == "" ? undefined: filtro.cpf,
                },
                tipoDeDocumento: filtro.tipoDeDocumento,
                documento: filtro.documento?.trim() == "" ? undefined: filtro.documento,
            }
        ),
        enabled: true,
    });

    const onFinish = ({
        ...valores
    }: IFiltro) => {
        setFiltro({
            ...valores,
            cpf: valores.cpf && Formatacoes.sanitizar(".-_", valores.cpf)
        });
    };

    const adicionarAberto = !!usuario?.permissoes.map((p) => p.nome).includes(Permissoes.CriarResponsavel);
    const [chavesDasLinhasExpandidas, setChavesDasLinhasExpandidas] = useState<React.Key[]>([])

    return (
        <React.Fragment>
            <Form form={form} onFinish={onFinish} autoComplete="off" layout="vertical" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                <Row gutter={[8, 8]} id={Tutoriais.IDs.formularioDeFiltro}>
                    <Form.Item<IFiltro> name="paginaInfo" hidden label="paginaInfo">
                        <input hidden />
                    </Form.Item>
                    <Col xs={24} xl={4} id={Tutoriais.IDs.filtroDeCPF}>
                        <Form.Item<IFiltro> name="cpf" label="CPF" style={{ marginBottom: 0 }}>
                            <InputComReactIMask maskOptions={{ mask: "000.000.000-00" }} />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={7} id={Tutoriais.IDs.filtroDeNome}>
                        <Form.Item<IFiltro> name="nome" label="Nome" style={{ marginBottom: 0 }}>
                            <Input placeholder="Nome" />
                        </Form.Item>
                    </Col>

                    <Col xs={24} xl={7} id={Tutoriais.IDs.filtroDeDocumento}>
                        <Space.Compact block>
                            <Form.Item<IFiltro> name="tipoDeDocumento" label="Documento" style={{ flex: 1, marginBottom: 0 }}>
                                <Select
                                    id={Tutoriais.IDs.filtroDeTipoDeDocumento}
                                    allowClear
                                    placeholder="Selecione"
                                    options={[
                                        { value: EnumTipoDeDocumento.RG, label: "RG" },
                                        { value: EnumTipoDeDocumento.RNE, label: "RNE" },
                                        { value: EnumTipoDeDocumento.PASSAPORTE, label: "Passaporte" },
                                    ]}
                                />
                            </Form.Item>

                            <Form.Item<IFiltro>
                                name="documento"
                                label={<></>}
                                style={{ flex: 2, marginBottom: 0 }}
                                dependencies={["tipoDeDocumento"]}
                                rules={[
                                    {
                                        transform(value) {
                                            if (value.trim() == "") return undefined;
                                            return value;
                                        },
                                        validator(_, value) {
                                            const tipo = form.getFieldValue("tipoDeDocumento");
                                            if (tipo == undefined && value != undefined) return Promise.reject("É necessário especificar o tipo de documento");
                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <Input id={Tutoriais.IDs.filtroDeValorDoDocumento} placeholder="Valor" />
                            </Form.Item>
                        </Space.Compact>
                    </Col>

                    <Col xs={24} xl={2} id={Tutoriais.IDs.filtroDeAtivo}>
                        <Form.Item<IFiltro> name="ativo" label="Ativo" initialValue={true} style={{ marginBottom: 0 }}>
                            <Select
                                allowClear
                                placeholder={"Todos"}
                                options={[
                                    { value: true, label: "Ativo" },
                                    { value: false, label: "Inativo" },
                                ]}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={[8, 8]}>
                    <Col xs={12} xl={3} id={Tutoriais.IDs.botaoListar}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" onClick={() => form.setFieldValue(["paginaInfo", "pagina"], 1)} disabled={isLoading} style={{ width: "100%" }}>
                                Listar
                            </Button>
                        </Form.Item>
                    </Col>

                    <Restrito aberto={adicionarAberto}>
                        <Col xs={12} xl={3} id={Tutoriais.IDs.botaoAdicionar}>
                            <Form.Item style={{ width: "100%" }}>
                                <Link
                                    to={props.hrefDoBotaoAdicionar ?? "#"}
                                    onClick={(e) => {
                                        !props.hrefDoBotaoAdicionar && e.preventDefault();
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            props.aoAdicionar?.();
                                        }}
                                        style={{ width: "100%" }}
                                    >
                                        Adicionar
                                    </Button>
                                </Link>
                            </Form.Item>
                        </Col>
                    </Restrito>
                </Row>
            </Form>

            <Row>
                <Col xs={24}>
                    <TablePaginadaBasic
                        dataSource={data?.data}
                        loading={isLoading}
                        rowKey={(k) => k.codigo ?? 0}
                        size={"small"}
                        showHeader={true}
                        disableResponsiveness={true}
                        tableLayout="auto"
                        bordered
                        locale={{ emptyText: "Nenhum responsável encontrado." }}
                        scroll={{
                            x : undefined,
                            y : "70vh"
                        }}
                        onChange={(pagina, ...restParam) => {
                            console.log("Pagina Change: ", pagina);
                            form.setFieldsValue({
                                paginaInfo : {
                                    pagina : pagina.current ?? 1,
                                    tamanho : pagina.pageSize ?? 20
                                }
                            } as any);

                            form.submit();
                        }}
                        expandable={{
                            showExpandColumn: false,
                            expandedRowRender: (record) => (
                                <div>
                                    <DescricaoDoResponsavel ocultarTitulo responsavel={record} />
                                    {/* <TextArea
                                style={{cursor: "pointer"}}    
                                onChange={() => {}}
                                value={JSON.stringify(record, null, '\t')} 
                                rows={20}
                                /> */}
                                </div>
                            ),
                            rowExpandable: () => true,
                            expandedRowKeys: chavesDasLinhasExpandidas,
                        }}
                        columns={[
                            {
                                title: "Código",
                                breakpoints: { xs: 12, sm: 12, lg: 2 },
                                dataIndex: "codigo",
                                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                                key: "responsavel-codigo",
                            },
                            {
                                title: "Ativo",
                                dataIndex: ["ativo"],
                                breakpoints: { xs: 12, sm: 12, lg: 2 },
                                key: "responsavel-ativo",
                                sorter: (a, b) => Ordenar.Booleano(a.ativo, b.ativo),
                                render: (v: boolean) => {
                                    return <>{v ? "Sim" : "Não"}</>;
                                },
                            },
                            {
                                title: "Nome",
                                breakpoints: { xs: 12, sm: 8, lg: 7 },
                                dataIndex: ["pessoa", "nome"],
                                sorter: (a, b) => Ordenar.String(a.pessoa?.nome, b.pessoa?.nome),
                                render(value, record, __) {
                                    return <div>{value} {(record?.pessoa?.bloqueios?.length ?? 0) > 0 && <StopTwoTone title="Bloqueado" twoToneColor="#ff4d4f" />}</div>
                                },
                                key: "responsavel-nome",
                            },
                            {
                                title: "CPF",
                                breakpoints: { xs: 12, sm: 8, lg: 8 },
                                dataIndex: ["pessoa", "cpf"],
                                sorter: (a, b) => Ordenar.String(a.pessoa?.cpf, b.pessoa?.cpf),
                                render: (val) => Formatacoes.formatarCPF(val) ?? "N/A",
                                key: "responsavel-cpf",
                            },
                            {
                                title: "Ações",
                                key: "acoes",
                                noResponsiveTitle: true,
                                breakpoints: { xs: 24, sm: 24, lg: 5 },
                                render: (_, item) => {
                                    return (
                                        <Conjunto
                                            style={{ justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: "wrap" }}
                                            itens={[
                                                <Button
                                                    type="dashed"
                                                    size="small"
                                                    icon={item.codigo && chavesDasLinhasExpandidas.includes(item.codigo) ? <MinusOutlined /> : <PlusOutlined />}
                                                    onClick={() => {
                                                        if (!item.codigo) return;

                                                        if (chavesDasLinhasExpandidas.includes(item.codigo)) {
                                                            setChavesDasLinhasExpandidas((prev) => prev.filter((v) => v != item.codigo));
                                                        } else {
                                                            setChavesDasLinhasExpandidas((prev) => [...prev, item.codigo!]);
                                                        }
                                                    }}
                                                ></Button>,
                                                ...(() => {
                                                    if (item.ativo) {
                                                        return [
                                                            usuario?.permissoes.map((p) => p.nome).includes(Permissoes.AtualizarResponsavel) && (
                                                                <Link
                                                                    to={props.hrefDoBotaoEditar?.(item) ?? "#"}
                                                                    onClick={(e) => !props.hrefDoBotaoEditar && e.preventDefault()}
                                                                >
                                                                    <Button
                                                                        className={Tutoriais.Classes.botaoEditar}
                                                                        type="primary"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            props.aoEditar?.(item);
                                                                        }}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                </Link>
                                                            ),
                                                            usuario?.permissoes.map((p) => p.nome).includes(Permissoes.DesativarResponsavel) && (
                                                                <Popconfirm
                                                                    {...PropriedadesDoPopConfirm("desativar")}
                                                                    onConfirm={() => {
                                                                        if (item.codigo == undefined) return;
                                                                        new ResponsavelService()
                                                                            .desativar(item.codigo)
                                                                            .then(() => {
                                                                                refetch();
                                                                            })
                                                                            .catch(() => {});
                                                                    }}
                                                                >
                                                                    <Button type="default" danger size="small" className={Tutoriais.Classes.botaoDesativar}>
                                                                        Desativar
                                                                    </Button>
                                                                </Popconfirm>
                                                            ),
                                                            !item?.pessoa?.bloqueios?.some?.(any => any.codBloqueioTipo == EnumBloqueioTipo.Manual) && <PessoaBloqueioBloquearModal
                                                                pessoa={item.pessoa!}
                                                                onSuccess={() => refetch()}
                                                            />,
                                                            (item?.pessoa?.bloqueios?.length ?? 0) > 0 && <PessoaBloqueioModal 
                                                                pessoa={item.pessoa!}
                                                                onSuccess={() => refetch()}
                                                            />
                                                        ];
                                                    } else {
                                                        return [
                                                            usuario?.permissoes.map((p) => p.nome).includes(Permissoes.AtivarResponsavel) && (
                                                                <Popconfirm
                                                                    {...PropriedadesDoPopConfirm("ativar")}
                                                                    onConfirm={() => {
                                                                        if (item.codigo == undefined) return;

                                                                        new ResponsavelService()
                                                                            .ativar(item.codigo)
                                                                            .then(() => {
                                                                                refetch();
                                                                            })
                                                                            .catch(() => {});
                                                                    }}
                                                                >
                                                                    <Button type="dashed" size="small">
                                                                        Reativar
                                                                    </Button>
                                                                </Popconfirm>
                                                            ),
                                                        ];
                                                    }
                                                })(),
                                            ]}
                                        />
                                    );
                                },
                            },
                        ]}
                        
                        csv={{
                            enabled: true,
                            filename: "responsaveis.csv",
                        }}
                    />
                </Col>
            </Row>

            <AdicionarAjuda
                tutoriais={
                    [
                        {
                            titulo: "Como consultar responsáveis",
                            tutorial: Tutoriais.ConsultarResponsavel,
                        },

                        permissoes?.includes(Permissoes.CriarResponsavel) && {
                            titulo: "Como cadastrar um novo responsável",
                            tutorial: Tutoriais.AdicionarResponsavel,
                        },

                        permissoes?.includes(Permissoes.AtualizarResponsavel) && {
                            titulo: "Como editar um responsável",
                            tutorial: Tutoriais.EditarResponsavel,
                        },

                        permissoes?.includes(Permissoes.DesativarResponsavel) && {
                            titulo: "Como desativar um responsável",
                            tutorial: Tutoriais.DesativarResponsavel,
                        },
                    ].filter((v) => v != false) as ITutorial[]
                }
            />
        </React.Fragment>
    );
}
